import { startCase } from "lodash";

export const normalizeCardBrand = (cardBrand: String) => {
  switch (cardBrand) {
    case "VISA":
      return "Visa";
    case "AMERICAN_EXPRESS":
      return "American Express";
    case "MASTERCARD":
      return "Mastercard";
    case "DISCOVER":
      return "Discover";
    case "SQUARE_GIFT_CARD":
      return "Gift Card";
    case "RAINCHECK":
      return "Raincheck";
    default:
      return startCase(cardBrand.toLowerCase());
  }
};
